import { ReactNode } from 'react';
import { isInsideTV } from '../utils/isInsideTV';
import { useFullScreen } from '../hooks/useFullScreen';

interface TVFrameProps {
    children: ReactNode;
}

function TVFrame({ children }: TVFrameProps) {
    const { active } = useFullScreen()
    if (active || isInsideTV()) {
        return <div className='w-screen h-screen bg-zinc-900 flex justify-center items-center overflow-hidden'>
            {children}
        </div>;
    }

    return (
        <div className="flex flex-col items-center justify-end w-full h-full bg-black">
            {/* TV Frame Container */}
            <div className="flex flex-col items-center w-[95%] h-[95%]">
                {/* TV Frame */}
                <div className="w-full aspect-[16/9] bg-[#333] rounded-lg overflow-hidden shadow-2xl">
                    {/* Thin Bezel */}
                    <div className="h-full m-[2px] bg-black rounded-lg overflow-hidden">
                        {/* Screen with Ambient Light Effect */}
                        <div className="relative h-full">
                            {/* Content Screen */}
                            <div className="h-full overflow-hidden">
                                {children}
                            </div>
                            {/* Ambient Light Effect */}
                            <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_100px_rgba(255,255,255,0.1)]" />
                        </div>
                    </div>
                </div>

                {/* TV Stand */}
                <div className="relative w-[25%] h-[60px]">
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[2px] h-full bg-gradient-to-b from-[#222] to-[#333]" />
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[120px] h-[10px] bg-[#333] rounded-lg" />
                </div>
            </div>
        </div>
    );

};

export default TVFrame;